import React, { Component } from "react";
import Chart from "react-apexcharts";

export default class UsersChart extends Component {
  constructor(props) {
    super(props);
    const colors = ["#35557F"];

    this.state = {
      //   series: [
      //     {
      //       name: "Users",
      //       data: [22, 22, 16, 15, 13, 12, 10, 7, 4],
      //     },
      //   ],
      series: this.props.usersSeries,

      options: {
        chart: {
          type: "bar",
          events: {
            click: function (chart, w, e) {
              // console.log(chart, w, e)
            },
          },
        },
        xaxis: {
          //   categories: [
          //     "Cust 2",
          //     "Cust 5",
          //     "Cust 3",
          //     "Cust 7",
          //     "Cust 8",
          //     "Cust 4",
          //     "Cust 6",
          //     "Cust 9",
          //     "Cust 1",
          //   ],
          categories: this.props.usersCategories,

          title: {
            text: "Customer", // Title for the X-axis
            style: {
              fontSize: "13px",
              fontWeight: "8px",
            },
          },
          labels: {
            style: {
              fontSize: "0.7rem", // Increase the font size here
              fontWeight: "bold", // Optional: make the font bold
              colors: ["#000000"], // Optional: change the label color if needed
            },
          },
        },
        yaxis: {
          title: {
            text: "Count", // Title for the X-axis
            style: {
              fontSize: "13px",
              fontWeight: "8px",
            },
          },
          labels: {
            formatter: function (val) {
              return parseInt(val);
            },
            style: {
              fontSize: "0.7rem", // Increase the font size here
              fontWeight: "bold", // Optional: make the font bold
              colors: ["#000000"], // Optional: change the label color if needed
            },
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#FFFFFF"],
            fontSize: "12px",
            fontWeight: 500,
          },
          background: {
            enabled: true,
            foreColor: "#656161",
            borderRadius: 2,
            padding: 4,
            opacity: 0.9,
            borderWidth: 1,
            borderColor: "#656161",
          },
          offsetY: -20,
        },
        legend: {
          show: false,
        },
        colors: colors,
        plotOptions: {
          bar: {
            columnWidth: "90%",
            distributed: true,
            borderRadius: 5,
            dataLabels: {
              position: "top",
            },
          },
        },
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.usersSeries !== this.props.usersSeries) {
      this.setState({ series: this.props.usersSeries });
    }
    if (prevProps.usersCategories !== this.props.usersCategories) {
      this.setState({
        options: {
          ...this.state.options,
          xaxis: {
            ...this.state.options.xaxis,
            categories: this.props.usersCategories,
          },
        },
      });
    }
  }

  render() {
    return (
      <div>
        <Chart
          options={this.state.options}
          series={this.state.series}
          type="bar"
          height={200}
        />
      </div>
    );
  }
}
